<app-form-section
  title="Seleccionar Territorios"
  icon="map"
  color="blue"
  contentClass="flex flex-col gap-4">

  <!-- Search Field -->
  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Buscar territorio</mat-label>
    <input matInput [formControl]="searchCtrl" placeholder="Código o nombre...">
    <mat-icon matPrefix>search</mat-icon>
    @if (searchCtrl.value) {
      <button matSuffix mat-icon-button (click)="clearSearch()">
        <mat-icon>clear</mat-icon>
      </button>
    }
  </mat-form-field>

  <!-- Selected Count Badge -->
  @if (modalService.selectedTerritoriesCount() > 0) {
    <div class="flex items-center gap-2 p-2 bg-blue-50 rounded-lg border border-blue-200">
      <mat-icon class="text-blue-500">check_circle</mat-icon>
      <span class="text-blue-700 font-medium">
        {{ modalService.selectedTerritoriesCount() }} territorio(s) seleccionado(s)
      </span>
    </div>
  }

  <!-- Territories Table Container -->
  <div class="table-container">
    <!-- Loading Overlay -->
    @if (isLoadingTerritories()) {
      <div class="table-loading-overlay">
        <mat-spinner diameter="30"></mat-spinner>
      </div>
    }

    <!-- Table -->
    <table mat-table [dataSource]="territoriesDataSource" class="w-full">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="w-12">
          <mat-checkbox
            color="primary"
            (change)="masterToggle()"
            [checked]="isAllSelected()"
            [indeterminate]="isIndeterminate()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="toggleRow(row)"
            [checked]="row.isSelected">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Code Column -->
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef class="font-semibold">Código</th>
        <td mat-cell *matCellDef="let row">
          <span class="font-medium">{{ row.code || '-' }}</span>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="font-semibold">Nombre</th>
        <td mat-cell *matCellDef="let row">
          <div class="flex items-center gap-2">
            {{ row.name }}
            @if (row.isAlreadyAssigned) {
              <span
                class="text-xs bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded"
                matTooltip="Este territorio ya está asignado a una dirección del cliente">
                Asignado
              </span>
            }
          </div>
        </td>
      </ng-container>

      <!-- Company Column -->
      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef class="font-semibold">Compañía</th>
        <td mat-cell *matCellDef="let row">
          <span class="text-sm text-gray-600">{{ row.companyName }}</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-50"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          (click)="toggleRow(row)"
          class="cursor-pointer hover:bg-gray-50"
          [class.bg-blue-50]="row.isSelected"></tr>
    </table>

    <!-- Empty State -->
    @if (!isLoadingTerritories() && territoriesDataSource.data.length === 0) {
      <div class="text-center py-8 text-gray-500">
        <mat-icon class="text-4xl mb-2">search_off</mat-icon>
        <p>No se encontraron territorios</p>
      </div>
    }
  </div>

  <!-- Paginator -->
  <mat-paginator
    [length]="totalTerritories()"
    [pageSize]="pageSize()"
    [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="currentPage() - 1"
    (page)="onPageChange($event)"
    showFirstLastButtons>
  </mat-paginator>

  <!-- Selected Territories Chips -->
  @if (modalService.selectedTerritoriesCount() > 0) {
    <div class="selected-territories">
      <label class="text-sm font-medium text-gray-700 mb-2 block">
        Seleccionados:
      </label>
      <mat-chip-set>
        @for (territory of modalService.selectedTerritories(); track territory._id) {
          <mat-chip
            class="territory-chip"
            [removable]="true"
            (removed)="removeFromSelection(territory)">
            <mat-icon matChipAvatar class="text-blue-500">map</mat-icon>
            {{ territory.code || territory.name }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        }
      </mat-chip-set>
    </div>
  }
</app-form-section>
